import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { APIService } from "./api.service";

@Injectable({
    providedIn: "root",
})
export class DashboardService extends APIService {
    constructor(http: HttpClient, router: Router) {
        super(http);
        this.endPoint = "candidates";
    }

    get_general_report() {
        return this.http.get(this.url + `/report_count`, this.httpOptions);
    }

    get_gender_report() {
        return this.http.get(this.url + `/report_gender`, this.httpOptions);
    }

    get_spec_report() {
        return this.http.get(this.url + `/report_majors`, this.httpOptions);
    }

    get_institutes_report() {
        return this.http.get(this.url + `/report_institutes`, this.httpOptions);
    }

    get_company_type_report() {
        return this.http.get(this.url + `/report_company_types`, this.httpOptions);
    }

    get_companies_report() {
        return this.http.get(this.url + `/report_companies`, this.httpOptions);
    }

    get_city_report() {
        return this.http.get(this.url + `/report_city`, this.httpOptions);
    }

    get_education_report() {
        return this.http.get(this.url + `/report_eduction`, this.httpOptions);
    }
}
